// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.66406 5.83594L8.46816 10.5988C9.01914 10.9845 9.29463 11.1773 9.59428 11.252C9.85897 11.318 10.1358 11.318 10.4005 11.252C10.7002 11.1773 10.9757 10.9845 11.5266 10.5988L18.3307 5.83594M5.66406 16.6693H14.3307C15.7309 16.6693 16.4309 16.6693 16.9657 16.3968C17.4361 16.1571 17.8186 15.7747 18.0582 15.3042C18.3307 14.7695 18.3307 14.0694 18.3307 12.6693V7.33594C18.3307 5.93581 18.3307 5.23574 18.0582 4.70096C17.8186 4.23056 17.4361 3.8481 16.9657 3.60842C16.4309 3.33594 15.7309 3.33594 14.3307 3.33594H5.66406C4.26393 3.33594 3.56387 3.33594 3.02909 3.60842C2.55868 3.8481 2.17623 4.23056 1.93655 4.70096C1.66406 5.23574 1.66406 5.93581 1.66406 7.33594V12.6693C1.66406 14.0694 1.66406 14.7695 1.93655 15.3042C2.17623 15.7747 2.55868 16.1571 3.02909 16.3968C3.56387 16.6693 4.26393 16.6693 5.66406 16.6693Z"
    />
  </svg>
);
const IconPurpleEmail = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconPurpleEmail;
